import httpClient from '../../shared/services/httpClient';

interface LoginData {
  email: string;
  password: string;
}

interface RecoverPasswordRequest {
  email: string;
}

interface ResetPasswordRequest {
  password: string;
  token: string;
}

export const auth = async (data: LoginData) => {
  const response = await httpClient.post('/login', data, { skipAuth: true });
  return response.data;
};

export const forgotPassword = async (data: RecoverPasswordRequest) => {
  const response = await httpClient.post('/login/forgot-password', data, { skipAuth: true });
  return response.data;
};

export const recoverPassword = async (data: ResetPasswordRequest) => {
  const response = await httpClient.post('/login/recover-password', data, { skipAuth: true });
  return response.data;
};
